import { apiRequest } from './api';
import type { Achievement, LiveStream, MediaItem, News, Player, Roster } from './types';

const TTL_MS = 30_000;
const cache = new Map<string, { at: number; promise: Promise<unknown> }>();

/** Short client-side cache for public reads (navigation back/forth, locale re-render). */
function getPublic<T>(path: string, signal?: AbortSignal): Promise<T> {
  const hit = cache.get(path);
  if (hit && Date.now() - hit.at < TTL_MS) return hit.promise as Promise<T>;
  const promise = apiRequest<T>(path, signal ? { signal } : {});
  cache.set(path, { at: Date.now(), promise });
  promise.catch(() => cache.delete(path));
  return promise;
}

export function invalidatePublic(): void {
  cache.clear();
}

export const loadNews = (s?: AbortSignal) => getPublic<{ items: News[] }>('/api/news', s).then((r) => r.items);
export const loadNewsItem = (id: number, s?: AbortSignal) =>
  getPublic<{ item: News }>(`/api/news/${id}`, s).then((r) => r.item);
export const loadAchievements = (s?: AbortSignal) =>
  getPublic<{ items: Achievement[] }>('/api/achievements', s).then((r) => r.items);
export const loadMedia = (s?: AbortSignal) => getPublic<{ items: MediaItem[] }>('/api/media', s).then((r) => r.items);
export const loadRosters = (s?: AbortSignal) => getPublic<{ items: Roster[] }>('/api/rosters', s).then((r) => r.items);
export const loadPlayer = (id: number, s?: AbortSignal) =>
  getPublic<{ item: Player }>(`/api/players/${id}`, s).then((r) => r.item);

export const loadLive = () => apiRequest<{ items: LiveStream[] }>('/api/live').then((r) => r.items);

export function isAbort(err: unknown): boolean {
  return err instanceof DOMException && err.name === 'AbortError';
}
